var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-toast',{attrs:{"header":"Registration is Closed","message":"We are not taking new registrations at this time"}})}
var staticRenderFns = []

export { render, staticRenderFns }